// ScrollToTopButton.jsx
import React, { useState, useEffect } from 'react';
import { useDarkMode } from './DarkModeContext';

const ScrollToTopButton = () => {
  const { darkMode } = useDarkMode();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!showScrollTop) return null;

  return (
    <button
      onClick={scrollToTop}
      // directly above the round chat button (ChatLauncher: 56px at 1rem), centered on it
      style={{ bottom: 'calc(5.25rem + env(safe-area-inset-bottom))' }}
      className={`fixed right-[22px] w-11 h-11 flex items-center justify-center rounded-full border shadow-lg transition-transform duration-300 active:scale-95 z-50 lg:hidden ${
        darkMode
          ? 'bg-white text-black border-gray-300'
          : 'bg-black text-white border-white/20'
      }`}
      aria-label="Scroll to top"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;